import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import type MarketSettingsCostIndexRoute from 'lumen/routes/market/settings/cost/index';
import type { ModelFrom } from 'lumen/utils/routes';

export default class MarketSettingsCostIndexController extends Controller {
  declare model: ModelFrom<MarketSettingsCostIndexRoute>;

  @service declare access: Services['access'];

  get isReadOnly(): boolean {
    return !this.access.hasCostProfilesEditAccess;
  }

  @action async refreshProfiles(): Promise<void> {
    await this.model.profiles.perform();
  }
}
